import React from 'react';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import {
  StyledCard,
  CardRow,
  LastRow,
  CardTitle,
  ContentInfo,
  CardIcon,
  TitleContainer,
  Title2,
  MoreIconButton
} from './styles';

function SimpleCardTemplate({
  title,
  icon,
  cardContents,
  onClickMore,
  diagram,
  onCardClickHeader
}) {
  return (
    <StyledCard aria-label="card-item">
      <CardRow
        onClick={onCardClickHeader}
        role="button"
        tabIndex={0}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            onCardClickHeader(e);
          }
        }}
      >
        <TitleContainer>
          <CardIcon>{icon}</CardIcon>
          <CardTitle m={0}>{title}</CardTitle>
        </TitleContainer>
        <MoreIconButton
          onClick={e => {
            e.stopPropagation();
            onClickMore();
          }}
        >
          <MoreHorizIcon />
        </MoreIconButton>
      </CardRow>
      {cardContents.map((cardContent, index) => {
        if (!cardContent.content) return null;
        const RowComponent = index === cardContents.length - 1 ? LastRow : CardRow;
        return (
          <RowComponent key={index}>
            <Title2
              color="textSecondary"
              fontWeight={500}
              m={0}
            >
              {cardContent.title}
            </Title2>
            <ContentInfo
              style={cardContent?.customStyles?.content}
            >
              {cardContent.content}
            </ContentInfo>
          </RowComponent>
        );
      })}
      {diagram ?
        <div>{diagram}</div> :
        null}
    </StyledCard>
  );
}

export default SimpleCardTemplate;
